import { render, staticRenderFns } from "./ClickToEdit.vue?vue&type=template&id=5af8c906"
import script from "./ClickToEdit.vue?vue&type=script&lang=js"
export * from "./ClickToEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports